import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../../../../i18n';
import PieChartIcon from '../../../../../icons/PieChartIcon';
import PieChartWhiteIcon from '../../../../../icons/PieChartWhiteIcon';
import Tile from '../../../../shared/Tile';
import PieChartDrawer from '../PieChartDrawer';
import usePieChartTile from './vm';

const PieChartTile = () => {
  const { t } = useTranslation([i18nNS.POLL]);

  const { isPieChartDrawerOpen, handleClosePieChartDrawer, handleClick } = usePieChartTile();

  return (
    <>
      <Tile
        icon={PieChartWhiteIcon}
        hoverIcon={PieChartIcon}
        title={t('pie_chart', { ns: i18nNS.POLL })}
        onClick={handleClick}
        isActive={isPieChartDrawerOpen}
      />
      <PieChartDrawer open={isPieChartDrawerOpen} onClose={handleClosePieChartDrawer} />
    </>
  );
};

export default PieChartTile;
